module.exports = __webpack_public_path__ + "static/media/commom-check.8aeadadb.svg";